// extracted by mini-css-extract-plugin
export default {"wrapper":"View_wrapper__X5Qcv","buttonEnd":"View_buttonEnd__52BDY","mr":"View_mr__PK8Yw","redButton":"View_redButton__WiN3g"};